import {
  Grid,
  Icon,
  Typography,
}                                                from "@gupshup-frontend/gupshup-ts-components";

import {
  PREVIEW_REGEX,
  BUTTON_LIST_TYPES,
  LIMITED_TIME_OFFER,
  TEMPLATE_PREVIEW_DATA_TESTID,
}                                                from "./constant";
import styles                                    from "./style.module.css";

const LimitedTimeOffer = ({ buttons, limitedTimeOffer }) => {

  const renderExpirationDays = () => {
    const expiryIn = limitedTimeOffer.ltoOfferCodeExpireIn ?? LIMITED_TIME_OFFER.EXPIRY_DAYS;
    if (PREVIEW_REGEX.LTO_CODE_REGEX.test(expiryIn)) {
      return LIMITED_TIME_OFFER.EXPIRY_SUBHEADER.replace(LIMITED_TIME_OFFER.DAYS, expiryIn);
    }

    const daysValue = parseInt(expiryIn, 10);

    if (!daysValue) {
      return "";
    }
    return `${LIMITED_TIME_OFFER.EXPIRY_SUBHEADER.replace(LIMITED_TIME_OFFER.DAYS, daysValue.toString())}${daysValue > 1 ? "s" : ""}`;
  };

  const renderOfferCode = () => {
    const offerButton = buttons.find(button => button.type === BUTTON_LIST_TYPES.COPY_CODE );
    return offerButton?.example?.toString() ?? "";
  };

  return (
    <Grid className = {styles.ltoPanel}>
      <Grid className = {styles.ltoIcon}>
        <Icon
          size       = {20}
          alt        = "Expiry Icon"
          customPath = {LIMITED_TIME_OFFER.EXPIRY_ICONPATH}
          dataTestId = {TEMPLATE_PREVIEW_DATA_TESTID.LTO_EXPIRY_ICON}
        />
      </Grid>
      <Grid display = "flex" flexDirection = "column" gap = {0.05}>
        <Typography variant = "body2" fontWeight = {600} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.LTO_EXPIRY_HEADER}>
          {limitedTimeOffer?.text || ""}
        </Typography>
        <Grid>
          {limitedTimeOffer.has_expiration &&
            <Typography className = {styles.ltoSubheader} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.LTO_EXPIRY_SUBHEADER}>
              {renderExpirationDays()}
            </Typography>
          }
          {renderOfferCode() &&
            <Typography className = {styles.ltoSubheaderCode} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.LTO_EXPIRY_CODE}>
              {`Code `}
              <strong>{renderOfferCode()}</strong>
            </Typography>
          }
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LimitedTimeOffer;
